import { render, staticRenderFns } from "./terms-dialog.vue?vue&type=template&id=7901eea1&scoped=true"
import script from "./terms-dialog.vue?vue&type=script&lang=js"
export * from "./terms-dialog.vue?vue&type=script&lang=js"
import style0 from "./terms-dialog.vue?vue&type=style&index=0&id=7901eea1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7901eea1",
  null
  
)

export default component.exports